<!-- src/app/pages/dashboard/t0-scenerios/t0-scenerios.component.html -->
<div class="grid grid-cols-1 lg:grid-cols-1 gap-4">
    <div class="bg-surface-0 rounded-2xl shadow-lg px-4 py-4 lg:px-6 lg:py-5">
        <div class="flex flex-col md:flex-row justify-between gap-3 mb-3">
            <div>
                <h2 class="text-sm font-semibold text-slate-900">Scenarios {{ displayRange$ | async }}</h2>
            </div>
            <div class="flex items-center gap-2 text-[11px] text-slate-500">
                <p-select [options]="metricOptions" [(ngModel)]="metric" optionLabel="label" optionValue="value" placeholder="Metric" styleClass="w-40"></p-select>
                <p-select [options]="groupOptions" [(ngModel)]="group" optionLabel="label" optionValue="value" placeholder="Group" styleClass="w-36"></p-select>
            </div>
        </div>

        @if (chart$ | async; as chart) {
            <p-chart type="line" [data]="chart.data" [options]="chart.options" style="height: 420px; width: 100%"></p-chart>
        }
    </div>
</div>
